import { useState } from 'react';
import { Car } from 'lucide-react';
import { GlassCard } from './SharedUI';
import { CollapseHeader, CollapseSection } from './NeuralSynthesisMonitor';
import { BydVehicleCard, useBydMockData } from './BydVehicleCard';

/**
 * 智能车控面板（独立卡片）
 * 从 NeuralSynthesisMonitor 抽离，受 "显示智能车控" 开关（xf_carcontrol_enabled）独立控制，
 * 与 "显示神经合成监控" / "显示米家设备" 互不依赖。
 */
export function CarPanel({ t }: { t?: any }) {
  const bydData = useBydMockData();
  const [bydCollapsed, setBydCollapsed] = useState(false);

  return (
    <GlassCard className="p-5 rounded-[2.5rem] space-y-1.5 border-white/5 bg-black/30 backdrop-blur-3xl">
      <div className="space-y-1">
        <CollapseHeader
          icon={<Car size={10} />}
          label={`智能车控 · ${bydData.deviceName}`}
          collapsed={bydCollapsed}
          onToggle={() => setBydCollapsed(v => !v)}
        />
        <CollapseSection collapsed={bydCollapsed}>
          <BydVehicleCard data={bydData} />
        </CollapseSection>
      </div>
    </GlassCard>
  );
}
